import { render, staticRenderFns } from "./DeviceRFIDDetailDialog.vue?vue&type=template&id=915d1156&scoped=true"
import script from "./DeviceRFIDDetailDialog.vue?vue&type=script&lang=js"
export * from "./DeviceRFIDDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DeviceRFIDDetailDialog.vue?vue&type=style&index=0&id=915d1156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915d1156",
  null
  
)

export default component.exports